import { useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography, { TypographyProps } from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';

import { addons } from '#addons';
import { renderAddonDetail, type Addon } from './common';

const PAGE_SIZE = 10;

export default function AddonList() {
  const [pageIndex, setPageIndex] = useState(0);

  const pageSize = Math.ceil(addons.length / PAGE_SIZE);

  const currentItems = addons.slice(
    pageIndex * PAGE_SIZE,
    pageIndex * PAGE_SIZE + PAGE_SIZE,
  );

  if (!currentItems.length && pageIndex !== 0) {
    setPageIndex(0);
  }

  return (
    <>
      <Box>
        <Typography variant={'h7' as TypographyProps['variant']} gutterBottom sx={{ fontWeight: 'fontWeightBold' as unknown as number }}>
          SWM Marketplace
        </Typography>
      </Box>
      <Stack spacing={2}>
        {
          currentItems.map(
            (addon, idx) => renderAddonDetail({ addon: addon as unknown as Addon, idx, details: false }),
          )
        }

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'end',
            px: 2,
          }}
        >
          <Box />
          {
            (pageSize > 1) && (
              <Pagination
                count={pageSize}
                page={pageIndex + 1}
                onChange={(e, page) => setPageIndex(page - 1)}
              />
            )
          }
        </Box>
      </Stack>
    </>
  );
}
